<template>
  <div class="reset-failed-container">
    <div class="reset-failed-card">
      <div class="error-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <line x1="15" y1="9" x2="9" y2="15"/>
          <line x1="9" y1="9" x2="15" y2="15"/>
        </svg>
      </div>
      <h1>Password Reset Failed</h1>
      <p class="description">
        {{ errorMessage }}
      </p>
      <router-link to="/login" class="back-to-login">
        Back to Login
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PasswordResetFailedView',
  computed: {
    errorMessage() {
      const reason = this.$route.query.reason
      switch (reason) {
        case 'token_expired':
          return 'Your password reset link has expired. Please request a new one.'
        case 'token_invalid':
          return 'This password reset link is invalid or has already been used.'
        case 'token_used':
          return 'This password reset link has already been used. Please request a new one if needed.'
        default:
          return 'Something went wrong while resetting your password. Please try again or request a new reset link.'
      }
    }
  }
}
</script>

<style scoped>
.reset-failed-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 100vh;
  padding: 20px;
  padding-top: 100px;
  background-color: var(--bg-primary);
}

.reset-failed-card {
  max-width: 450px;
  width: 100%;
  padding: 40px;
  background-color: var(--bg-secondary);
  border-radius: 8px;
  box-shadow: var(--shadow);
  border: 1px solid var(--border-color);
  text-align: center;
}

.error-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  border: 2px solid var(--error-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--error-color);
}

.error-icon svg {
  width: 40px;
  height: 40px;
}

h1 {
  color: var(--text-primary);
  font-size: 1.75rem;
  font-weight: 600;
  margin: 0 0 16px;
}

.description {
  color: var(--text-secondary);
  font-size: 1rem;
  line-height: 1.6;
  margin: 0 0 24px;
}

.back-to-login {
  display: inline-block;
  padding: 12px 32px;
  background-color: var(--accent-color);
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-weight: 600;
  transition: background-color 0.2s;
}

.back-to-login:hover {
  background-color: var(--accent-hover);
}
</style>
